import axios from '@/plugin/axios'
import api from '@/api'

export const openSession = {
  sessionsStats,
  sessionsList,
  orgSessionsStats
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data)
    }).catch(e => {
      if (e.code === 404 && e.message === 'Not Found') resolve([] as any)
      else reject(e)
    })
  })
}

function getOneYearDateRange(): { startDate: string; endDate: string } {
  const endDate = new Date()
  const startDate = new Date(endDate)
  startDate.setFullYear(startDate.getFullYear() - 1)
  const formatISO = (date: Date): string => date.toISOString().split('.')[0] + 'Z'
  return {
    startDate: formatISO(startDate),
    endDate: formatISO(endDate)
  }
}

function sessionsStats(business_unit: string): Promise<any> {
  const {startDate, endDate} = getOneYearDateRange()
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_USER_SESSION_STATS, {
    params: {
      business_unit: business_unit.toUpperCase(),
      startDate,
      endDate
    }
  }))
}

function orgSessionsStats(locationId: string): Promise<any> {
  const {startDate, endDate} = getOneYearDateRange()
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_STATS, {
    params: {
      locationId,
      startDate,
      endDate
    }
  }))
}

function sessionsList(sessionStatus: string, business_unit: string, username: string | null = null): Promise<any> {
  const {startDate, endDate} = getOneYearDateRange()
  const params: Record<string, string> = {
    sessionStatus,
    startDate,
    endDate,
    business_unit: business_unit.toUpperCase()
  }
  if (username) {
    params.username = username
  }
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_USER_SESSION_LIST, {
    params
  }))
}
